import { leftVersionGreaterThanOrEqualToRight } from '@standardnotes/common';
export function serverKeyParamsAreSafe(serverParams, clientParams) {
    return leftVersionGreaterThanOrEqualToRight(serverParams.version, clientParams.version);
}
